import { FormContext } from '@sec-loans-ui/ifp-loans/steps/formContext'
import { WizardStep } from '@sec-loans-ui/ifp-loans/wizard/wizardMachine'
import { ImplicitlySubmittableForm } from '@ui-common/components/ImplicitlySubmittableForm'
import { useWizardForm } from '@ui-common/hooks'
import { getFullname } from '@ui-common/utils'
import { LogoIconType } from '@ui-components/global/ComponentProps'
import { CompletionProgress, PhasesView } from '@ui-components/layout/PhasesView'
import { WizardStep as WizardStepComponent } from '@ui-components/layout/WizardStep'
import { use, useRef } from 'react'
import { FormProvider } from 'react-hook-form'
import { useIntl } from 'react-intl'

// TODO DIG-5778, DIG-5762, DIG-5780 - Actual Implementation
export const StatusStep = () => {
  const intl = useIntl()
  const { wizardData, exitWithConfirmDialog, user, proceed } = use(FormContext)
  const phasesViewRef = useRef<HTMLDivElement>(null)
  const methods = useWizardForm({
    defaultValues: wizardData,
  })

  const showSummary = false

  return (
    <WizardStepComponent
      stepId={WizardStep.StatusStep}
      isLoading={false}
      title={''}
      headerButtonProps={{
        headerButtonLabel: intl.formatMessage({ id: 'common-exit' }),
        onHeaderButtonClick: exitWithConfirmDialog,
      }}
      additionalText={getFullname({ firstName: user?.firstNames, lastName: user?.lastName })}
      subHeaderOptions={{
        title: 'PLACEHOLDER Lyhennysvapaa',
        description: 'PLACEHOLDER 3 kk Euribor (165 300 €)',
        secondaryTopBarMenuProps: {
          menuAriaLabelOpen: '',
          menuAriaLabelClose: '',
          // https://www.figma.com/design/ml1rtba3eCgfeD9vR2DSQj/-3---Installment-free-period--spring-2025-?node-id=757-11386&t=86mIXQnOnmZ1tFrl-4
          menuOptions: [
            {
              text: 'PLACEHOLDER Uusi hakemus',
              onClick: () => null,
            },
          ],
        },
      }}
      icon={LogoIconType.SPankki}
      shouldShowMainHeader={true}
      pageHeroContent={
        <PhasesView
          ref={phasesViewRef}
          progress={CompletionProgress.NotStarted}
          instructions={{
            [CompletionProgress.NotStarted]: { title: 'PLACEHOLDER NotStarted title', text: 'NotStarted text' },
            [CompletionProgress.Started]: { title: 'PLACEHOLDER Started title', text: 'Started text' },
            [CompletionProgress.Incomplete]: { title: 'PLACEHOLDER Incomplete title', text: 'Incomplete text' },
            [CompletionProgress.IncompletePastHalf]: {
              title: 'PLACEHOLDER IncompletePastHalf title',
              text: 'PLACEHOLDER IncompletePastHalf text',
            },
            [CompletionProgress.Complete]: { title: 'Complete title', text: 'Complete text' },
          }}
          phasesHeader={'PLACEHOLDER phasesHeader'}
          phases={[
            {
              header: 'PLACEHOLDER Hakemuksen tiedot',
              content: {
                icon: 'controlEditIcon',
                text: 'PLACEHOLDER Kesto: 10-15 min',
                action: {
                  label: 'PLACEHOLDER go to step ',
                  kind: 'content',
                  onClick: () => proceed({}),
                },
              },
              isComplete: false,
            },
            // eslint-disable-next-line formatjs/no-literal-string-in-jsx
            { header: 'PLACEHOLDER Hakemuksen lähetys', content: <p>PLACEHOLDER content</p>, isComplete: false },
          ]}
          shouldShowCompletedPhases={false}
          fullViewportHeight={!showSummary}
        />
      }
    >
      {showSummary && (
        <FormProvider {...methods}>
          <ImplicitlySubmittableForm onSubmit={() => methods.handleSubmit} isLoading={false}>
            {/*{children}*/}
          </ImplicitlySubmittableForm>
        </FormProvider>
      )}
    </WizardStepComponent>
  )
}
